import React from 'react';
//interfaces
import { ITooltip } from './interface';
// generics
import * as S from './styles';

const Tooltip = ({ 
  children, 
  disable, 
  color, 
  bottom, 
  left, 
  width, 
  height, 
  maxWidth, 
  padding, 
  maxHeight, 
  areaBottom, 
  areaRight, 
  border, 
  overflow, 
  boxShadow
}: ITooltip) => {
  return (
    <S.TooltipArea 
      areaBottom={areaBottom} 
      areaRight={areaRight} 
      border={border} 
      boxShadow={boxShadow}
    >
      {disable &&
        <S.Tooltip 
          color={color} 
          bottom={bottom} 
          left={left} 
          width={width} 
          height={height} 
          maxWidth={maxWidth} 
          maxHeight={maxHeight} 
          padding={padding} 
          overflow={overflow}
        >
          {children}
        </S.Tooltip>}
    </S.TooltipArea>
  );
};

export default Tooltip;